import cn from "classnames"
import { useEffect, useState } from "react"

import { Button, Card, Text, Tooltip } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CloudSync, SyncOutlined } from "@/icons"
import { CopyButton } from "@/molecules/CopyButton"
import { useDeployCommandValues } from "@/pages/DeploymentsPage/hooks/useDeployCommandValues"

import styles from "./DeployCommand.module.scss"

import type { DeployCommandProps } from "."

export const DeployCommand = (props: DeployCommandProps) => {
  const { children, getDefaultValues, noError, classes = {} } = props
  const { t } = useTranslation()
  const [error, setError] = useState(!noError)
  const [currentValues, setValues] = useDeployCommandValues()

  const onChange = ({ name, value }: any) => {
    setValues({ ...currentValues, [name]: value })
  }

  const onError = () => setError(true)

  useEffect(() => {
    setValues((prevState) => ({
      ...prevState,
      ...getDefaultValues(props)
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const values = currentValues.key ? currentValues : getDefaultValues(props)

  return (
    <Card
      className={cn(styles.container, classes.container, error && styles.error)}
    >
      {!error && (
        <>
          <div className={styles.content}>
            {children({ values, onChange, onError })}
          </div>
          <div className={styles.buttons}>
            <Tooltip title={t("general.reset")}>
              <Button
                icon={<SyncOutlined />}
                size="small"
                onClick={() => {
                  setValues({ ...values, ...getDefaultValues() })
                }}
              />
            </Tooltip>
            <CopyButton
              type="primary"
              text={props.getDeployCommand(values, getDefaultValues(), props)}
            >
              {t("general.copy")}
            </CopyButton>
          </div>
        </>
      )}
      {error && (
        <>
          <CloudSync className={styles.icon} />
          <Text className={styles.text}>
            {t("deployments.error.loadError")}
          </Text>
        </>
      )}
    </Card>
  )
}
